// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table .el-image[data-v-6098b449] {\n  width: auto !important;\n  height: 30px !important;\n}\n.table[data-v-6098b449] ::v-deepel-image__inner,\n.table .el-image__placeholder[data-v-6098b449],\n.table .el-image__error[data-v-6098b449] {\n  width: auto !important;\n}\n.info[data-v-6098b449] {\n  width: 63%;\n}", ""]);
// Exports
module.exports = exports;
